import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRandomSelectIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 7,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 5,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 17,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 15,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 10,
			r: 2,
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 18,
			r: 2,
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 20,
			r: 2,
			opacity: .3
		})
	]
});
export default SvgRandomSelectIcon;
